import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { useSyncJobNotificationStore } from '@/v2/domains/Jobs/stores/syncJobNotification.store';
import { notification } from '@/v2/components/Notification/notification';
import useGetJobQuery from '@/v2/domains/Jobs/queries/useGetJobQuery.hook';
import {
  JOB_STATUS,
  SKIP_SYNC_JOB_NOTIFICATION_PATHS,
} from '@/v2/domains/Jobs/constants/constants';
import Button from '@/v2/components/Button/Button';

export default function useSyncJobNotification() {
  const [ready, setReady] = useState(false);
  const { jobId, reset } = useSyncJobNotificationStore();
  const router = useRouter();

  const { data: job } = useGetJobQuery({
    jobId: ready ? jobId : null,
    refetch: true,
  });

  useEffect(() => {
    const jobStatus = job?.status;
    if (jobStatus === JOB_STATUS.SUCCESS || jobStatus === JOB_STATUS.ERROR) {
      reset();
      if (SKIP_SYNC_JOB_NOTIFICATION_PATHS.includes(router.asPath)) {
        return;
      } else if (jobStatus === JOB_STATUS.SUCCESS) {
        notification.success({
          message: 'Your classes have been synced successfully.',
          description: (
            <Link href="/classes">
              <Button size="sm" type="link">
                Go to classes
              </Button>
            </Link>
          ),
        });
      } else if (jobStatus === JOB_STATUS.ERROR) {
        notification.error({
          message: 'There was an error with the sync process.',
          description: 'Please try again.',
        });
      }
    }
  }, [job]);

  return {
    init: () => setReady(true),
  };
}
